import Swiper, { Autoplay, Pagination } from 'swiper';

/**
 * @class Slider
 *
 * Create a slider
 */
class Slider {
    constructor (el) {
        this.el = el;

        this.slider = new Swiper(this.el, {
            modules: [Autoplay, Pagination],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            speed: 1000,
            on: {
                transitionEnd: function () {
                    this.params.speed = 1000;
                },
                touchStart: function () {
                    this.params.speed = 200;
                }
            },
            slidesPerView: 'auto',
            centeredSlides: true,
            centerInsufficientSlides: true,
            grabCursor: true,
            breakpoints: {
                768: {
                    centeredSlides: false
                }
            }
        });
    }
}

export default Slider;
